import { authRoles } from 'app/auth';
import LandingPage from './LandingPage';

export const LandingPageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.demo,
	routes: [
		{
			path: '/landing-page',
			component: LandingPage
		}
	]
};
